/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import * as amplify from '@classic/AppUtils/Framework/Messaging/amplifyjs'
import Guard from '../Guard'

export function subscribe(topic: string, func: Function, context?: unknown): void {
  Guard.stringNotNullOrEmpty(topic)
  Guard.notNull(func)

  if (context) amplify.subscribe(topic, context, func)
  else amplify.subscribe(topic, func)
}

export function publish(topic: string, ...args: unknown[]): void {
  Guard.stringNotNullOrEmpty(topic)

  amplify.publish(topic, ...args)
}

export function unsubscribe(topic: string, func: Function): void {
  amplify.unsubscribe(topic, func)
}
